import axios from "axios";
import { useEffect, useState } from "react";
import axiosInstant from "../../../axiosInstant";
import { decodeId } from "../../../hash";

export default function SearchAuction(pageNumber, id, search, searchCat) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [lotdata, setLot] = useState([]);
  const [hasMore, setHasMore] = useState(false);

  useEffect(() => {
    setLot([]);
    setHasMore(true); // I-reset din ito pag nagbago ang filters
  }, [id, search, searchCat]);

  useEffect(() => {
    setLoading(true);
    setError(false);
    let cancel;

    axiosInstant({
      method: "GET",
      url: `private-sales/lot?id=${decodeId(id)}&pgroup=EXHIBITION&search=${
        search || ""
      }&cat=${searchCat || ""}&page=${pageNumber || 1}`,
      cancelToken: new axios.CancelToken((c) => (cancel = c)),
    })
      .then((res) => {
        const newData = res.data.msg;
        setLot((prevlotdata) => [...new Set([...prevlotdata, ...newData])]);
        
        // Check kung may laman pa ang next page
        setHasMore(newData.length > 0);
        setLoading(false);
      })
      .catch((e) => {
        if (axios.isCancel(e)) return;
        
        setError(true);
        setLoading(false);
        setHasMore(false); // <--- IMPORTANTE: Itigil ang pagination pag may error

        // Opsyonal: I-check specifically ang status code
        if (e.response && (e.response.status === 403 || e.response.status === 500)) {
           console.error("Stopping pagination due to error:", e.response.status);
        }
      });

    return () => cancel();
  }, [pageNumber, id, search, searchCat]);

  return { lotdata, hasMore, loading, error };
}